<template>
  <div class="container">
    <topbar :key="chainstoreKey" :storeData="chainstore" />
    <storeCardList :storeGroupId="chainstore_id" />
    <mainFooter />
  </div>
</template>
<script>
import topbar from "./topbar"
import storeCardList from "./storeCardList"
import mainFooter from "./mainFooter"
import { getChainstoreInfo } from '@/api/api'

export default {
  data() {
    return {
      chainstore_id: 0,
      chainstore: {},
    }
  },
  components: {
    topbar, mainFooter, storeCardList
  },
  created() {
    this.chainstore_id = this.$route.query.chainstore_id || 0
    this.fetchData()
  },
  methods: {
    async fetchData(){
      getChainstoreInfo("/app/index.php?i=2&c=entry&m=weisrc_dish&do=get_chainstore_info", {chainstore_id:this.chainstore_id}).then(res => {
        this.chainstoreKey = +(new Date())
        this.chainstore = res.data
        document.title = res.data.chainstore_name
      }).catch(err => {})
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');
.container {
  padding-top: 55px;
  padding-bottom: 80px;
}
</style>